import { DataTable } from "@marketplace/ui/data-table";

import type { ClaimHistoryListItem } from "../../dtos/get-claim-history-list-response-dto";
import { useClaimHistoryListTableColumns } from "../../hooks/use-claim-history-list-table-columns";

type ClaimHistoryTableProps = {
  records: ClaimHistoryListItem[];
  page: number;
};

export const ClaimHistoryTable: React.FC<ClaimHistoryTableProps> = ({
  records,
  page
}) => {
  const { columns } = useClaimHistoryListTableColumns(page);

  return (
    <DataTable
      minHeight={10}
      columns={columns}
      records={records}
      idAccessor="public_id"
    />
  );
};
